export enum LocalStorageKeyEnum {
  TOKENID = 'TOKENID',
  JWTTOKEN = 'JWTTOKEN',
  USERID = 'USERID',
  ADMIN = 'IS_ADMIN',
}
